import { Container, FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DrawerForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  margin: "auto",
  width: "fit-content",
  paddingTop: theme.spacing(2),
}));

export const DrawerFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: 300,
  paddingBottom: theme.spacing(2),
}));

export const DrawerButtonContainer = styled(Container)({
  flex: "0 0 auto",
  display: "flex",
  justifyContent: "flex-end",
  height: "70px",
  width: "100%",
  background: "white",
});

export const DrawerButtonGroup = styled("div")(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));
